import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { HelpCircle } from "lucide-react";
import { FAQS } from "../mock";

export default function FAQ() {
  return (
    <section className="py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 text-amber-300">
            <HelpCircle className="w-5 h-5" />
            <span className="text-xs font-semibold uppercase tracking-[0.2em]">FAQs</span>
          </div>
          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-slate-100">Common Questions</h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-white/5 bg-[#11172a] rounded-xl px-5 data-[state=open]:border-amber-400/30"
            >
              <AccordionTrigger className="text-left text-slate-100 hover:text-amber-200 hover:no-underline py-4">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-400 pb-4 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
